import Solution from "./solution";
import compare from "../../Utils/compare2dArray";

const testCases = [
  {
    arr: [
      [1, 3],
      [2, 6],
      [8, 10],
      [15, 18],
    ],
  },
  {
    arr: [
      [1, 4],
      [4, 5],
    ],
  },
  {
    arr: [
      [1, 19],
      [8, 10],
      [15, 18],
    ],
  },
];

const test = (code) => {
  try {
    const updatedFunc = `${code.trim()}`;
    const output = new Function(updatedFunc);
    for (let test of testCases) {
      const { arr } = test;
      let outcome2 = Solution(arr);
      let temp = [...arr];
      let outcome1 = output()(temp);
      const result = compare(outcome1, outcome2);
      if (!result) {
        return {
          status: "failed",
          details: { input: test, output: outcome1, expected: outcome2 },
        };
      }
    }

    return { status: "success", details: {} };
  } catch (e) {
    return {
      status: "error",
      details: { message: `${e.name}: ${e.message}` },
    };
  }
};

export default test;
